import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { makeGetTaskSectionIdForProjectId } from '../../../../../redux/tasks/tasksToProjectsRelation/selectors';
import { reorderTasksAction } from '../../../../../redux/tasks/actions';
import { getProjectTasksFilters } from '../../../../../redux/general/selectors';
import { makeGetSectionTitleSelector } from '../../../../../redux/sections/selectors';
import { socketSendAction } from '../../../../../redux/state-areas/socket/actions';

const ConnectedSectionDropdownItemLabel = ({
  currentSectionId,
  filters,
  loggedUser,
  projectId,
  sectionId,
  sectionTitle,
  taskId,
}) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(reorderTasksAction(currentSectionId, sectionId, taskId, 0, 0, projectId));
  };

  return (
    <div className="d-flex p-1 w-full" onClick={handleClick}>
      <div className="truncate max-w-60">
        <FormattedMessage id={`${sectionTitle}`.replaceAll(' ', '_').toUpperCase()} defaultMessage={sectionTitle || ''} />
      </div>
    </div>
  );
};

const makeMapStateToProps = () => {
  const getTaskSectionIdForProjectId = makeGetTaskSectionIdForProjectId();
  const getSectionTitleSelector = makeGetSectionTitleSelector();
  return (state, props) => ({
    currentSectionId: getTaskSectionIdForProjectId(state, props),
    filters: getProjectTasksFilters(state),
    loggedUser: state.userReducer.user,
    sectionTitle: getSectionTitleSelector(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedSectionDropdownItemLabel);
